<template>
    <button @click.stop="visitLanding" class="footer-button">
        <svg width="20px" height="20px" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Search-/-Explore" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Main---New-Nav" transform="translate(-29.000000, -748.000000)" stroke="#000000" stroke-width="1.2">
                    <polygon id="Path-2" points="30 764 45 764 45 753.722498 37.5 749 30 753.722498"></polygon>
                </g>
            </g>
        </svg>
        <span>Home</span>
    </button>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        computed: {
        },
        methods: {
            visitLanding(){
                this.$router.push({path: '/'});
                this.$emit('click');
            },
        }
    }
</script>
